/* import __COLOCATED_TEMPLATE__ from './payments.hbs'; */
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryCellsPayments extends Component {
  get paymentValue() {
    const item = this.args.item;

    switch (item.constructor.modelName) {
      case 'appointment':
      case 'group-appointment':
        return item.totalAllocatedAmount || 0;
      case 'invoice-item':
        return item.allocatedAmount || 0;
      case 'payment':
        return item.amount || 0;
      default:
        return null;
    }
  }
}
